import React from 'react';
import '../Components/ComponentCss/ViewAllComponent.css';
import CompanyCardListInName from "./CompanyCardListInName";

// 불변성을 제공해 필요하지 않은 렌더링 억제
const companyCardOption = {
    editDisabled: true,
    hideCompanyName: true,
    hideRoomNumber: true,
};

const ViewAllComponent = ({ data, year }) => { // props에서 CompanyName만 구조 분해 할당
    return (
        <div className={"view-all-component"}>
            <div className={'view-all-component-year'}>{year}년</div>
            <div className={"Payment-paytitle-box"}>
                <div className={'pay'}>년월</div>
                <div className={'pay'}>임대료</div>
                <div className={'pay'}>부가세</div>
                <div className={'pay'}>전기세</div>
                <div className={'pay'}>도시가스</div>
                <div className={'pay'}>총 미납액</div>
            </div>
            {data?.map((payment, idx) =>
                <CompanyCardListInName key={idx} data={payment} option={companyCardOption}/>
            )}
        </div>
    );
};

export default ViewAllComponent;
